import { instance } from '@/libs/api/instance'

export const getOobRequests = () => {
  return instance.get('/v1/card/oob-requests')
}
